<template>
  <div class="PMS6003-view">
    <weatherBar v-bind="status" style="margin-bottom: 10px" />
    <sensortList :list="seneorList" />
  </div>
</template>

<script>
let pmNameObj = {
  pm1: 'PM1.0 浓度',
  pm25: ' PM2.5',
  pm10: 'PM10',
  pmLevel: 'pm等级',
  pm1Atm: 'PM1.0 浓度（大气环境下)',
  pm25Atm: 'PM2.5 浓度（大气环境下)',
  pm10Atm: 'PM10 浓度（大气环境下)',
  parCount1: '0.3以上颗粒数',
  parCount2: '0.5以上颗粒数',
  parCount3: '1.0以上颗粒数',
  parCount4: '2.5以上颗粒数',
  parCount5: '5.0以上颗粒数',
  parCount6: '10以上颗粒数'
};
let pmUnit = ['pm1', 'pm25', 'pm10', 'pmLevel', 'pm1Atm', 'pm25Atm', 'pm10Atm'];

import { getSensorsGradeServer } from '@/api/devices';

import weatherBar from '../components/weather-status-bar.vue';
import singleDeviceMixin from '@/mixins/singleDeviceMixin';
import sensortList from '@/components/sensorList/index.vue';

export default {
  name: 'PMS6003',
  mixins: [singleDeviceMixin],
  sockets: {
    '/socket/detail'(res) {
      this.update(res);
    }
  },
  data() {
    return {
      seneorList: [],
      status: {
        humidity: 0,
        temp: 0
      }
    };
  },
  methods: {
    loadSensorGradeHandler() {
      let sensorType = ['GM606', 'RG04', 'PMS6003', 'NRH-M01'];
      getSensorsGradeServer(sensorType).then(res => {
        this.seneorGrade = res.data;
      });
    },
    update(res) {
      if (res.sn === this.sn) {
        this.setData(res);
      }
    },
    setData(res) {
      let { deviceType, mods, beginTime } = res;

      if (mods.hasOwnProperty('weatherMod')) {
        this.status = mods.weatherMod;
      }

      let newPMS6003Data = [];
      delete mods.smokeMod.pmDto.pmFault;

      Object.keys(mods.smokeMod.pmDto).forEach(key => {
        let obj = {
          name: key,
          showName: Object.keys(pmNameObj).includes(key) ? pmNameObj[key] : key,
          value: mods.smokeMod.pmDto[key],
          deviceType,
          beginTime,
          alarmState: 0
        };
        if (pmUnit.includes(key)) {
          obj.unitName = 'ug/m³';
        } else {
          obj.unitName = '个';
        }
        newPMS6003Data.push(obj);
      });
      this.seneorList = newPMS6003Data;

      this.seneorList.forEach((item, index) => {
        let { deviceType, name, value } = item;
        if (!this.seneorGrade.hasOwnProperty(deviceType)) return;

        this.seneorGrade[deviceType].forEach(sitem => {
          if (sitem.sensorTypeCode.includes(name)) {
            sitem.deviceSensorTypeGradeDtos.forEach(sensorItem => {
              if (
                value >= Number(sensorItem.gradeLowValue) &&
                value <= Number(sensorItem.gradeHighValue)
              ) {
                this.seneorList[index].color = sensorItem.gradeMark;
              }
            });
          }
        });
      });
    }
  },
  components: { weatherBar, sensortList },
  created() {
    this.loadSensorGradeHandler();
  }
};
</script>

<style scoped lang="scss">
.PMS6003-view {
  width: 100%;
}
</style>
